export default "__VITE_ASSET__17a2f30b__"